import React, { useState } from "react";

//importing Components
// import TopNav from "../components/top-nav";
// import LeftNav from "../components/left-menu";
// import HeadTitle from "../components/global/HeadTitle";
// import Filter from "../components/filter";

//importing icons
import { BsEnvelope } from "react-icons/bs";
import { AiOutlineStar, AiOutlineHeart } from "react-icons/ai";
import { IoMdAddCircleOutline } from "react-icons/io";

//importing Assets
import Pic from "../../assets/images/ahmedeldesoky.jpeg";

export const ChatBox = () => {
  const [selectOption, setSelectOption] = useState("");

  const handleOption = (e) => {
    // console.log(e.target.textContent);
    setSelectOption(e.target.textContent);
  };

  return (
    <div className="support">
      <div className="support__chat-box">
        <div className="chat-box">
          <div className="row-flex">
            <div className="message__box-img">
              <img src={Pic} alt="" className="chat-box__img" />
            </div>
            <p className="chat-box__text">
              Hello, I’m FitBot! 👋 I’m your Your medical advisor. How can I
              help you?
            </p>
            <p className="text--gray">4:15</p>
          </div>
          <div className="row-flex">
            <div className="message__box-img">
              <img src={Pic} alt="" className="chat-box__img" />
            </div>
            <p className="chat-box__text">
              <h4 className="text--primary">Ok, Let’s Start?</h4>
              <ul className="chat-box__bot" onClick={handleOption}>
                <li
                  className="menu-btn__item chat-box__bot-option"
                  onClick={() => setSelectOption("service")}
                >
                  yes
                </li>
                <li
                  className="menu-btn__item chat-box__bot-option"
                  onClick={() => setSelectOption("help")}
                >
                  {" "}
                  no
                </li>
              </ul>
            </p>
            <p className="text--gray">4:15</p>
          </div>
          {selectOption === "yes" && (
            <div className="row-flex">
              <div className="message__box-img">
                <img src={Pic} alt="" className="chat-box__img" />
              </div>
              <p className="chat-box__text">
                <h4 className="text--primary"> Question 1 ?</h4>
                <ul className="chat-box__bot">
                  <li
                    className="menu-btn__item chat-box__bot-option"
                    onClick={handleOption}
                  >
                    {" "}
                    yes
                  </li>
                  <li
                    className="menu-btn__item chat-box__bot-option"
                    onClick={handleOption}
                  >
                    {" "}
                    no
                  </li>
                </ul>
              </p>
              <p className="text--gray">4:15</p>
            </div>
          )}
          {selectOption && (
            <div className="row-flex-reverse">
              <div className="message__box-img">
                <img src={Pic} alt="" className="chat-box__img" />
              </div>
              <p className="chat-box__text-second"> {selectOption} </p>
              <p className="text--gray">4:15</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
